<template>
	<div v-if="gridViews" class="grid-flex-container">
		<div class="grid-toolbar mb-4" v-if="gridViews">
			<v-tabs @change="onTabItemChanged">
				<v-tab v-for="(gridView, index) in gridViews" :key="index">{{
					gridView.Name
				}}</v-tab>
			</v-tabs>
		</div>
		<div
			class="d-flex flex-grow-1"
			style="overflow-y: hidden"
			v-if="selectedGridView"
		>
			<v-col cols="4" class="mt-0">
				<connectors-list v-if="selectedGridView" />
			</v-col>
			<v-col class="mt-0">
				<connector-details v-if="selectedGridView" />
			</v-col>
		</div>
	</div>
	<v-container v-else>
		<v-row no-gutters>
			<h3 class="warning">No Dataset fields configuration found!</h3>
		</v-row>
	</v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import {
	ConnectorsGetters,
	ConnectorsListGetters,
} from '../../../store/getters';
import {
	ConnectorsActions,
	ConnectorsListActions,
} from '../../../store/actions';
import ConnectorDetails from './details/ConnectorDetails.vue';
import ConnectorsList from './ConnectorsList.vue';
export default {
	name: 'Connectors',
	components: {
		ConnectorsList,
		ConnectorDetails,
	},
	computed: {
		...mapGetters({
			gridViews: [ConnectorsGetters.GRID_VIEWS],
			selectedGridView: [ConnectorsListGetters.SELECTED_GRID_VIEW],
		}),
	},

	mounted() {
		this.$store.dispatch(ConnectorsActions.LOAD_GRIDVIEWS);
	},
	destroyed() {
		this.$store.dispatch(ConnectorsActions.CLEAR);
	},
	methods: {
		onTabItemChanged(index) {
			this.$store.dispatch(ConnectorsListActions.CLEAR).then(() => {
				this.$store.dispatch(
					ConnectorsListActions.LOAD_SELECTED_GRID_VIEW,
					this.gridViews[index]
				);
			});
		},
	},
};
</script>
<style>
.v-tabs-bar {
	height: 41px;
}
</style>
